export default [
  {
    component: () => import("@/components/configuracoes/emitente/gerenciar-emitentes.vue"),
    name: "configuracoes.emitentes.gerenciar",
    path: "/configuracoes/emitentes/gerenciar",
    label: "Gerenciar Emitentes",
  },
  {
    component: () => import("@/components/configuracoes/emitente/visualizar-emitente.vue"),
    name: "configuracoes.emitentes.visualizar",
    path: "/configuracoes/emitentes/visualizar/:id",
    label: "Visualizar Emitente",
  },
  {
    component: () => import("@/components/configuracoes/emitente/form-emitente.vue"),
    name: "configuracoes.emitentes.novo",
    path: "/configuracoes/emitentes/novo",
    label: "Cadastrar Emitentes",
  },
  {
    component: () => import("@/components/configuracoes/emitente/form-emitente.vue"),
    name: "configuracoes.emitentes.editar",
    path: "/configuracoes/emitentes/editar/:id",
    label: "Editar Emitentes",
  },
  {
    component: () => import("@/components/configuracoes/contrato/ContratoPage.vue"),
    name: "configuracoes.contrato",
    path: "/configuracoes/contrato",
    label: "Contrato",
  },
  {
    component: () => import("@/components/configuracoes/usuarios/editor-usuario.vue"),
    name: "configuracoes.usuarios.editar",
    label: "Editar Usuários",
    path: "/configuracoes/usuarios/editar/:id",
  },
  {
    component: () => import("@/components/configuracoes/usuarios/novo-usuario.vue"),
    name: "configuracoes.usuarios.novo",
    path: "/configuracoes/usuarios/novo",
    label: "Cadastrar Usuários",
  },
  {
    component: () => import("@/components/configuracoes/usuarios/gerenciar-usuarios.vue"),
    name: "configuracoes.usuarios",
    path: "/configuracoes/usuarios/gerenciar",
    label: "Visualizar Usuários",
  },
  {
    component: () => import("@/components/configuracoes/emitente/home-emitente.vue"),
    name: "configuracoes.emitentes",
    path: "/configuracoes/emitentes",
    label: "Emitentes",
  },
  {
    component: () => import("@/components/configuracoes/usuarios/config-inicial.vue"),
    name: "configuracoes.iniciais",
    path: "/configuracoes/iniciais",
    label: "Configurações Iniciais de Integração",
  },
  {
    component: () => import("@/components/configuracoes/usuarios/config-info-fiscal.vue"),
    name: "configuracoes.info-fiscal",
    path: "/config-info-fiscal",
    label: "Configurações Info. Fiscal",
  },
  {
    component: () => import("@/components/home/MenuConfiguracoes.vue"),
    name: "configuracoes",
    path: "/configuracoes",
    label: "Configurações",
  },
  {
    component: () => import("@/components/configuracoes/AtualizacaoCnpj.vue"),
    name: "configuracoes.atualizacao-cnpj",
    path: "/configuracoes/atualizacao-cnpj",
    label: "Atualização cadastral por CNPJ",
    meta: { skipPermissionCheck: true },
  },
  {
    component: () => import("@/components/configuracoes/submenus/SubmenuConfiguracoesEmpresa.vue"),
    name: "configuracoes.empresa",
    path: "/configuracoes/empresa",
    label: "Empresa",
    // Hub de navegação: visível para quem tem acesso a qualquer um dos seus itens.
    meta: {
      permission: ["configuracoes.emitentes", "configuracoes.inscricoes-estaduais", "configuracoes.etiquetas"],
    },
  },
  {
    component: () => import("@/components/configuracoes/submenus/SubmenuConfiguracoesAcessos.vue"),
    name: "configuracoes.acessos",
    path: "/configuracoes/acessos",
    label: "Usuários e Acessos",
    meta: {
      permission: ["configuracoes.usuarios", "configuracoes.perfis-de-acesso", "configuracoes.limites-de-acesso"],
    },
  },
  {
    component: () => import("@/components/configuracoes/submenus/SubmenuConfiguracoesIntegracoes.vue"),
    name: "configuracoes.integracoes",
    path: "/configuracoes/integracoes",
    label: "Integrações",
    meta: {
      permission: [
        "configuracoes.integracao-ia",
        "configuracoes.mcp",
        "configuracoes.integracao-catalogo-api",
        "configuracoes.extensao-crm",
        "configuracoes.dominio-sistemas",
        "configuracoes.email-teste",
      ],
    },
  },
  {
    component: () => import("@/components/configuracoes/submenus/SubmenuConfiguracoesImplantacao.vue"),
    name: "configuracoes.implantacao",
    path: "/configuracoes/implantacao",
    label: "Implantação",
    meta: {
      permission: ["configuracoes.implantacao-xml", "configuracoes.implantacao-formulacoes"],
    },
  },
  {
    component: () => import("@/components/minha-conta/minha-conta.vue"),
    name: "configuracoes.minha-conta",
    path: "/configuracoes/minha-conta",
    label: "Minha Conta",
  },
  {
    component: () => import("@/components/configuracoes/inscricoes-estaduais/inscricoes-estaduais.vue"),
    name: "configuracoes.inscricoes-estaduais",
    path: "/configuracoes/inscricoes-estaduais",
    label: "Inscrições Estaduais",
  },
  {
    component: () => import("@/components/configuracoes/etiquetas/TemplatesEtiquetas.vue"),
    name: "configuracoes.etiquetas",
    path: "/configuracoes/etiquetas",
    label: "Etiquetas: Templates",
  },
  {
    component: () => import("@/components/configuracoes/etiquetas/TemplateEtiquetaForm.vue"),
    name: "configuracoes.etiquetas.novo",
    path: "/configuracoes/etiquetas/novo",
    label: "Novo Template de Etiqueta",
  },
  {
    component: () => import("@/components/configuracoes/etiquetas/TemplateEtiquetaForm.vue"),
    name: "configuracoes.etiquetas.editar",
    path: "/configuracoes/etiquetas/:id/editar",
    label: "Editar Template de Etiqueta",
  },
  {
    component: () => import("@/components/configuracoes/rbac/gerenciar-perfis-de-acesso.vue"),
    name: "configuracoes.perfis-de-acesso",
    path: "/configuracoes/perfis-de-acesso",
    label: "Visualizar Perfis de Acesso",
  },
  {
    component: () => import("@/components/configuracoes/rbac/novo-perfil-de-acesso.vue"),
    name: "configuracoes.perfis-de-acesso.novo",
    path: "/configuracoes/perfis-de-acesso/novo",
    label: "Criar Perfis de Acesso",
  },
  {
    component: () => import("@/components/configuracoes/rbac/novo-perfil-de-acesso.vue"),
    name: "configuracoes.perfis-de-acesso.editar",
    path: "/configuracoes/perfis-de-acesso/editar/:id",
    label: "Editar Perfis de Acesso",
  },
  {
    component: () => import("@/components/configuracoes/rbac/limites-de-acesso.vue"),
    name: "configuracoes.limites-de-acesso",
    path: "/configuracoes/limites-de-acesso",
  },
  {
    component: () => import("@/components/integracao/IntegracaoIA.vue"),
    name: "configuracoes.integracao-ia",
    path: "/configuracoes/integracao-ia",
    label: "Integração IA",
  },
  {
    component: () => import("@/components/implantacao/ImplantacaoPage.vue"),
    name: "configuracoes.implantacao-xml",
    path: "/configuracoes/implantacao-xml",
    label: "Implantação XML",
  },
  {
    component: () => import("@/components/implantacao/FormulacoesPlanilhaPage.vue"),
    name: "configuracoes.implantacao-formulacoes",
    path: "/configuracoes/importar-formulacoes",
    label: "Importar Formulações",
  },
  {
    component: () => import("@/components/integracao/mcp-connectors.vue"),
    name: "configuracoes.mcp",
    path: "/configuracoes/integracoes/mcp",
    label: "Conectores MCP",
  },
  {
    component: () => import("@/components/integracao/ErpCatalogoApiPage.vue"),
    name: "configuracoes.integracao-catalogo-api",
    path: "/configuracoes/integracao/catalogo-api",
    label: "API de Catálogo ERP",
  },
  {
    component: () => import("@/components/configuracoes/extensao-crm/ExtensaoCrmWhatsapp.vue"),
    name: "configuracoes.extensao-crm",
    path: "/configuracoes/extensao-crm",
    label: "Extensão CRM WhatsApp",
  },
  {
    component: () => import("@/components/integracao/DominioSistemas.vue"),
    name: "configuracoes.dominio-sistemas",
    path: "/configuracoes/dominio-sistemas",
    label: "Domínio Sistemas",
  },
  {
    component: () => import("@/components/configuracoes/email/TestEmail.vue"),
    name: "configuracoes.email-teste",
    path: "/configuracoes/email-teste",
    label: "Teste de E-mail",
  },
];
